module.exports = __webpack_public_path__ + "img/icon_edit_active.022ae415.svg";